import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import PageLayout from 'components/PageLayout';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getPeople } from 'store/people/peopleActions';
import { PeopleActionTypes } from 'store/people/peopleTypes';
import BirthdayDetails from './BirthdayDetails';

export default function Birthday() {
  const dispatch = useDispatch();

  const onMountPage = () => dispatch(getPeople());
  const onUnmountPage = () => dispatch({ type: PeopleActionTypes.CLEAR });

  return (
    <>
      <Box>
        <Grid>
          <PageLayout
            details={<BirthdayDetails />}
            onMountPage={onMountPage}
            onUnmountPage={onUnmountPage}
          />
        </Grid>
      </Box>
    </>
  );
}
